import React from 'react';
import { UUID } from '@umanforge/common';
import { SectorFetched } from 'interfaces/types.interface';
import { EventManagerWithPosition } from 'interfaces/eventManager.interface';
import ArrayButtonsHome from '../home/ArraysButtonsHome';
import TabsSlider from '@common_components/buttons/TabsSlider.component';
interface HomeContentProps {
  sectors: SectorFetched[];
  tables: EventManagerWithPosition[];
  selectedSectorId: UUID | undefined;
  setTables: React.Dispatch<React.SetStateAction<EventManagerWithPosition[]>>;
  goToTableManagement: ( tableName: string, tableId: string ) => void;
  setPopupVisible: React.Dispatch<React.SetStateAction<boolean>>;
  handleSectorClick: ( sectorIndex: number ) => void;
  onDragModeChange: ( isDragMode: boolean ) => void;
}

const HomeContent: React.FC<HomeContentProps> = ( {
  sectors,
  tables,
  selectedSectorId,
  setTables,
  goToTableManagement,
  setPopupVisible,
  handleSectorClick,
  onDragModeChange
} ) => {

  return (
    <div className="w-full p-6 max-md:mx-0 max-md:px-4 bg-white rounded-b-xl border border-t-transparent h-full">
      {selectedSectorId && (
        <TabsSlider
          sectors={sectors}
          onSectorClick={handleSectorClick}
          selectedIndex={sectors.findIndex( sector => {return sector.id === selectedSectorId;} )}
        />
      )}
      {selectedSectorId && (
        <ArrayButtonsHome
          sectorId={selectedSectorId}
          tables={tables}
          setTables={setTables}
          goToTableManagement={goToTableManagement}
          setPopupVisible={setPopupVisible}
          onDragModeChange={onDragModeChange}
        />
      )}
    </div>
  );
};

export default HomeContent;
